// extracted by mini-css-extract-plugin
export default {"tags":"TagList_tags__Oqa2O","tag":"TagList_tag__gybWV"};